/*jshint browserify: true */
'use strict';

var BoxDrawMode = require('./BoxDrawMode.js');

/**
 * @name SelectionMode
 *
 * User can select elements on the PDF, as well as perform a variety of other basic edit operations (move, resize, etc.)
 */

    function SelectionMode(pdfElements, selectedPdfElements, pages) {
        BoxDrawMode.call(this, pdfElements, selectedPdfElements, pages);

        this._subMode = SelectionMode.subModes.NONE;
        this._subModeObject = new SelectionSubModeDefault(this);
        this._elementsBeingManipulated = [];
    }

    SelectionMode.prototype = Object.create(BoxDrawMode.prototype);
    SelectionMode.prototype.constructor = SelectionMode;

    SelectionMode.subModes = Object.freeze({
        NONE: 'None',
        SELECT: 'Select',
        MOVE: 'Move',
        RESIZE: 'Resize',
        TEXT_SPACING: 'TextSpacing'
    });

    SelectionMode.prototype.onMouseMove = function (mouseEvent, page) {
        if (this._mouseIsDown === true) {
            BoxDrawMode.prototype.onMouseMove.call(this, mouseEvent, page);

            if (this._subMode === SelectionMode.subModes.NONE) {
                // Determine which submode to set

                var newMode = null;

                newMode = SelectionSubModeTextSpacingEdit.checkForSubMode(mouseEvent, page, this);
                if (newMode) {
                    this._subMode = SelectionMode.subModes.TEXT_SPACING;
                    this._subModeObject = newMode;
                    return;
                }

                newMode = SelectionSubModeResize.checkForSubMode(mouseEvent, page, this);
                if (newMode) {
                    this._subMode = SelectionMode.subModes.RESIZE;
                    this._subModeObject = newMode;
                    return;
                }

                newMode = SelectionSubModeMove.checkForSubMode(mouseEvent, page, this);
                if (newMode) {
                    this._subMode = SelectionMode.subModes.MOVE;
                    this._subModeObject = newMode;
                    return;
                }

                this._subMode = SelectionMode.subModes.SELECT;
                this._subModeObject = new SelectionSubModeSelect(this);
            } else {
                this._subModeObject.onMouseMove(mouseEvent, page);
            }

        } else {
            // Hit-test element edges to determine whether cursor should change to indicate resize capability

            var mousePosition = coordinates.Position.fromMouseEvent(mouseEvent, page.pageViewport, page.pdfOverlayCanvasElement);

            var edgeTestResult = '';
            for (var i = 0; i < this.pdfElements.length; i++) {
                if (this.pdfElements[i].pageNumber === page.pageNumber) {
                    edgeTestResult = this.pdfElements[i].edgeTest(page.pageViewport, page.pdfOverlayCanvasElement, mousePosition);
                    if (edgeTestResult !== '') {
                        i = this.pdfElements.length;
                    }
                }
            }

            this.cursor = SelectionSubModeResize.cursorForEdge(edgeTestResult);
        }
    };

    /**
     * @returns {Array} Instances of PDFedit.elements.PdfElement that are within the selection rectangle drawn by the user.
     *   Array will be empty if the interaction is not in select sub-mode (e.g. it's in move mode).
     */
    SelectionMode.prototype.getElementsWithinSelectionRectangle = function () {
        if (this._subModeObject instanceof SelectionSubModeSelect) {
            return this._subModeObject.getElementsWithinSelectionRectangle();
        } else {
            return [];
        }
    };

    SelectionMode.prototype.onMouseUp = function (mouseEvent, page) {
        if (mouseEvent.button === 0 && this._mouseIsDown === true && this._mouseEndPage === page) {
            this._mouseIsDown = false;
            this._elementsBeingManipulated.length = 0;
            this.cursor = 'auto';

            this._subModeObject.onMouseUp(mouseEvent, page);
            this._subMode = SelectionMode.subModes.NONE;
            this._subModeObject = new SelectionSubModeDefault(this);
        }
    };

    SelectionMode.prototype.onMouseClick = function (mouseEvent, page) {
        this._subModeObject.onMouseClick(mouseEvent, page);
    };

    SelectionMode.prototype.renderToCanvas = function (page) {
        this._subModeObject.renderToCanvas(page);
    };

    

var SelectionSubModeBase = (function SelectionSubModeBaseClosure() {
    /**
     * @param {PDFedit.uimodes.SelectionMode} selectionMode - The SelectionMode object
     */
    function SelectionSubModeBase(selectionMode) {
        this._selectionMode = selectionMode;
    }

    SelectionSubModeBase.prototype = {
        onMouseMove: function (mouseEvent, page) { },
        onMouseClick: function (mouseEvent, page) { },
        onMouseUp: function (mouseEvent, page) { },
        renderToCanvas: function (page) { }
    };

    return SelectionSubModeBase;
})();

var SelectionSubModeDefault = (function SelectionSubModeDefaultClosure() {
    function SelectionSubModeDefault(selectionMode) {
        SelectionSubModeBase.call(this, selectionMode);
    }

    SelectionSubModeDefault.prototype = Object.create(SelectionSubModeBase.prototype);
    SelectionSubModeDefault.prototype.constructor = SelectionSubModeDefault;

    SelectionSubModeDefault.prototype.onMouseClick = function (mouseEvent, page) {
        var mouseMoved = this._selectionMode._mouseStart !== null && this._selectionMode._mouseEnd !== null &&
            (this._selectionMode._mouseStart.pdfX !== this._selectionMode._mouseEnd.pdfX || this._selectionMode._mouseStart.pdfY !== this._selectionMode._mouseEnd.pdfY);

        if (mouseEvent.button === 0 && !mouseMoved) {
            var mousePosition = coordinates.Position.fromMouseEvent(mouseEvent, page.pageViewport, page.pdfOverlayCanvasElement);

            var clickedElement = null;
            for (var i = 0; i < this._selectionMode.pdfElements.length; i++) {
                if (this._selectionMode.pdfElements[i].pageNumber === page.pageNumber && this._selectionMode.pdfElements[i].hitTest(page.pageViewport, page.pdfOverlayCanvasElement, mousePosition)) {
                    clickedElement = this._selectionMode.pdfElements[i];
                    break;
                }
            }

            if (clickedElement === null) {
                this._selectionMode.selectedPdfElements.length = 0;
            } else if (mouseEvent.shiftKey || mouseEvent.ctrlKey) {
                var idx = this._selectionMode.selectedPdfElements.indexOf(clickedElement);
                if (idx === -1) {
                    this._selectionMode.selectedPdfElements.push(clickedElement);
                } else {
                    this._selectionMode.selectedPdfElements.splice(idx, 1);
                }
            } else {
                this._selectionMode.selectedPdfElements.length = 0;
                this._selectionMode.selectedPdfElements[0] = clickedElement;
            }
        }
    };

    return SelectionSubModeDefault;
})();

var SelectionSubModeMove = (function SelectionSubModeMoveClosure() {
    function SelectionSubModeMove(selectionMode) {
        SelectionSubModeBase.call(this, selectionMode);
    }

    SelectionSubModeMove.prototype = Object.create(SelectionSubModeBase.prototype);
    SelectionSubModeMove.prototype.constructor = SelectionSubModeMove;

    SelectionSubModeMove.prototype.onMouseMove = function (mouseEvent, page) {
        var offsetXmove = this._selectionMode._mouseEnd.pdfX - this._selectionMode._mouseStart.pdfX;
        var offsetYmove = this._selectionMode._mouseEnd.pdfY - this._selectionMode._mouseStart.pdfY;

        if (this._selectionMode._mouseStartPage !== this._selectionMode._mouseEndPage) {
            offsetYmove = coordinates.Position.fromMouseEvent(this._selectionMode._mouseEnd, this._selectionMode._mouseStartPage.pageViewport, this._selectionMode._mouseStartPage.pdfOverlayCanvasElement).pdfY - this._selectionMode._mouseStart.pdfY;
        }

        for (var i = 0; i < this._selectionMode._elementsBeingManipulated.length; i++) {
            this._selectionMode._elementsBeingManipulated[i].element.pageNumber = this._selectionMode._elementsBeingManipulated[i].originalPosition.pageNumber;
            this._selectionMode._elementsBeingManipulated[i].element.x = this._selectionMode._elementsBeingManipulated[i].originalPosition.x + offsetXmove;
            this._selectionMode._elementsBeingManipulated[i].element.y = this._selectionMode._elementsBeingManipulated[i].originalPosition.y + offsetYmove;

            var currentPage = this._selectionMode.pages[this._selectionMode._elementsBeingManipulated[i].element.pageNumber - 1];
            var spaceBetweenPages;

            if (offsetYmove < 0 && this._selectionMode._elementsBeingManipulated[i].element.y < 0) {
                // Moving down, and off the end of the page

                while (this._selectionMode._elementsBeingManipulated[i].element.y < 0 && this._selectionMode._elementsBeingManipulated[i].element.pageNumber < this._selectionMode.pages.length) {
                    currentPage = this._selectionMode.pages[this._selectionMode._elementsBeingManipulated[i].element.pageNumber - 1];
                    var nextPage = this._selectionMode.pages[this._selectionMode._elementsBeingManipulated[i].element.pageNumber];
                    var nextPageHeight = nextPage.pageViewport.height / nextPage.pageViewport.scale;
                    spaceBetweenPages = (nextPage.pdfOverlayCanvasElement.getBoundingClientRect().top - currentPage.pdfOverlayCanvasElement.getBoundingClientRect().bottom) / nextPage.pageViewport.scale;

                    this._selectionMode._elementsBeingManipulated[i].element.y = this._selectionMode._elementsBeingManipulated[i].element.y + nextPageHeight + spaceBetweenPages;
                    this._selectionMode._elementsBeingManipulated[i].element.pageNumber = nextPage.pageNumber;
                }

                // Don't let the element go off the end of the last page
                if (this._selectionMode._elementsBeingManipulated[i].element.y < 0) {
                    this._selectionMode._elementsBeingManipulated[i].element.y = 0;
                }
            }

            if (offsetYmove > 0 && this._selectionMode._elementsBeingManipulated[i].element.y + this._selectionMode._elementsBeingManipulated[i].element.height > currentPage.pageViewport.height / currentPage.pageViewport.scale) {
                // Moving up, and off the top of the page

                while (this._selectionMode._elementsBeingManipulated[i].element.y + this._selectionMode._elementsBeingManipulated[i].element.height > currentPage.pageViewport.height / currentPage.pageViewport.scale &&
                    this._selectionMode._elementsBeingManipulated[i].element.pageNumber > 1) {

                    var previousPage = this._selectionMode.pages[this._selectionMode._elementsBeingManipulated[i].element.pageNumber - 2];
                    var currentPageHeight = currentPage.pageViewport.height / currentPage.pageViewport.scale;
                    spaceBetweenPages = (currentPage.pdfOverlayCanvasElement.getBoundingClientRect().top - previousPage.pdfOverlayCanvasElement.getBoundingClientRect().bottom) / previousPage.pageViewport.scale;

                    this._selectionMode._elementsBeingManipulated[i].element.y = this._selectionMode._elementsBeingManipulated[i].element.y - currentPageHeight - spaceBetweenPages;
                    this._selectionMode._elementsBeingManipulated[i].element.pageNumber = previousPage.pageNumber;

                    currentPage = previousPage;
                }

                // Don't let the element go off the top of the first page
                if (this._selectionMode._elementsBeingManipulated[i].element.y + this._selectionMode._elementsBeingManipulated[i].element.height > currentPage.pageViewport.height / currentPage.pageViewport.scale) {
                    this._selectionMode._elementsBeingManipulated[i].element.y = (currentPage.pageViewport.height / currentPage.pageViewport.scale) - this._selectionMode._elementsBeingManipulated[i].element.height;
                }
            }
        }
    };

    /**
     * @param {MouseEvent} mouseEvent
     * @param {PDFedit.document.Page} page - The page that the mouse event occurred on
     * @param {PDFedit.uimodes.SelectionMode} selectionMode - The SelectionMode object
     *
     * @return {Object} An instance of this sub-mode if this is the sub-mode to be used, otherwise null
     */
    SelectionSubModeMove.checkForSubMode = function (mouseEvent, page, selectionMode) {
        for (var i = 0; i < selectionMode.pdfElements.length; i++) {
            if (selectionMode.pdfElements[i].pageNumber === selectionMode._mouseStartPage.pageNumber &&
                selectionMode.pdfElements[i].hitTest(selectionMode._mouseStartPage.pageViewport, selectionMode._mouseStartPage.pdfOverlayCanvasElement, selectionMode._mouseStart)) {

                selectionMode._elementsBeingManipulated.length = 0;

                if (selectionMode.selectedPdfElements.indexOf(selectionMode.pdfElements[i]) === -1) {
                    // Element clicked is not part of existing selection, change the selection to include only it, and move it
                    selectionMode.selectedPdfElements.length = 0;
                    selectionMode.selectedPdfElements.push(selectionMode.pdfElements[i]);
                    selectionMode._elementsBeingManipulated.push({
                        element: selectionMode.pdfElements[i],
                        originalPosition: {
                            x: selectionMode.pdfElements[i].x,
                            y: selectionMode.pdfElements[i].y,
                            width: selectionMode.pdfElements[i].width,
                            height: selectionMode.pdfElements[i].height,
                            pageNumber: selectionMode.pdfElements[i].pageNumber
                        }
                    });
                } else {
                    // Element clicked is part of existing selection, move all selected elements
                    for (var j = 0; j < selectionMode.selectedPdfElements.length; j++) {
                        selectionMode._elementsBeingManipulated.push({
                            element: selectionMode.selectedPdfElements[j],
                            originalPosition: {
                                x: selectionMode.selectedPdfElements[j].x,
                                y: selectionMode.selectedPdfElements[j].y,
                                width: selectionMode.selectedPdfElements[j].width,
                                height: selectionMode.selectedPdfElements[j].height,
                                pageNumber: selectionMode.selectedPdfElements[j].pageNumber
                            }
                        });
                    }
                }

                selectionMode.cursor = 'move';
                i = selectionMode.pdfElements.length;
                return new SelectionSubModeMove(selectionMode);
            }
        }

        return null;
    };

    return SelectionSubModeMove;
})();

var SelectionSubModeResize = (function SelectionSubModeResizeClosure() {
    function SelectionSubModeResize(selectionMode, resizeEdgeAnchor) {
        SelectionSubModeBase.call(this, selectionMode);

        this._resizeEdgeAnchor = resizeEdgeAnchor || '';
    }

    SelectionSubModeResize.prototype = Object.create(SelectionSubModeBase.prototype);
    SelectionSubModeResize.prototype.constructor = SelectionSubModeResize;

    SelectionSubModeResize.prototype.onMouseMove = function (mouseEvent, page) {
        for (var i = 0; i < this._selectionMode._elementsBeingManipulated.length; i++) {
            var offsetX = this._selectionMode._mouseEnd.pdfX - this._selectionMode._mouseStart.pdfX;
            var offsetY = this._selectionMode._mouseEnd.pdfY - this._selectionMode._mouseStart.pdfY;

            var element = this._selectionMode._elementsBeingManipulated[i].element;
            var originalPosition = this._selectionMode._elementsBeingManipulated[i].originalPosition;

            var minimumWidth = -1;
            if (element instanceof PdfTextElement && element.characterSpacings.length) {
                var minimumCharacterEndSpacing = element.fontSize / 2;
                minimumWidth = element.characterSpacings.reduce(function (a, b) { return a + b; });
                minimumWidth += minimumCharacterEndSpacing;
            }


            if (this._resizeEdgeAnchor.indexOf('left') !== -1) {
                if (minimumWidth !== -1 && originalPosition.width - offsetX < minimumWidth) {
                    offsetX = originalPosition.width - minimumWidth;
                }

                if (originalPosition.width - offsetX > 0) {
                    element.x = originalPosition.x + offsetX;
                    element.width = originalPosition.width - offsetX;
                } else {
                    element.x = originalPosition.x + originalPosition.width;
                    element.width = offsetX - originalPosition.width;
                }
            }

            if (this._resizeEdgeAnchor.indexOf('right') !== -1) {
                if (minimumWidth !== -1 && originalPosition.width + offsetX < minimumWidth) {
                    offsetX = minimumWidth - originalPosition.width;
                }

                if (originalPosition.width + offsetX > 0) {
                    element.x = originalPosition.x;
                    element.width = originalPosition.width + offsetX;
                } else {
                    element.x = originalPosition.x + originalPosition.width + offsetX;
                    element.width = 0 - offsetX - originalPosition.width;
                }

                if (element.width < minimumWidth) {
                    element.width = minimumWidth;
                }
            }

            if (this._resizeEdgeAnchor.indexOf('top') !== -1) {
                if (originalPosition.height + offsetY > 1) {
                    element.y = originalPosition.y;
                    element.height = originalPosition.height + offsetY;
                } else {
                    element.y = originalPosition.y + originalPosition.height + offsetY;
                    element.height = 0 - offsetY - originalPosition.height;
                }
            }

            if (this._resizeEdgeAnchor.indexOf('bottom') !== -1) {
                if (originalPosition.height - offsetY > 1) {
                    element.y = originalPosition.y + offsetY;
                    element.height = originalPosition.height - offsetY;
                } else {
                    element.y = originalPosition.y + originalPosition.height;
                    element.height = offsetY - originalPosition.height;
                }
            }
        }
    };

    /**
     * Determine which cursor to display for mouse hover on the provided element edge
     */
    SelectionSubModeResize.cursorForEdge = function (edge) {
        if (edge === 'top-left' || edge === 'bottom-right') {
            return 'nwse-resize';
        } else if (edge === 'top-right' || edge === 'bottom-left') {
            return 'nesw-resize';
        } else if (edge === 'left' || edge === 'right') {
            return 'ew-resize';
        } else if (edge === 'top' || edge === 'bottom') {
            return 'ns-resize';
        } else {
            return 'auto';
        }
    };

    /**
     * @param {MouseEvent} mouseEvent
     * @param {PDFedit.document.Page} page - The page that the mouse event occurred on
     * @param {PDFedit.uimodes.SelectionMode} selectionMode - The SelectionMode object
     *
     * @return {Object} An instance of this sub-mode if this is the sub-mode to be used, otherwise null
     */
    SelectionSubModeResize.checkForSubMode = function (mouseEvent, page, selectionMode) {
        var resizeEdgeAnchor = '';

        for (var i = 0; i < selectionMode.pdfElements.length; i++) {
            if (selectionMode.pdfElements[i].pageNumber === selectionMode._mouseStartPage.pageNumber) {
                resizeEdgeAnchor = selectionMode.pdfElements[i].edgeTest(selectionMode._mouseStartPage.pageViewport, selectionMode._mouseStartPage.pdfOverlayCanvasElement, selectionMode._mouseStart);
                if (resizeEdgeAnchor !== '') {
                    selectionMode.selectedPdfElements.length = 0;
                    selectionMode.selectedPdfElements.push(selectionMode.pdfElements[i]);
                    selectionMode._elementsBeingManipulated.length = 1;
                    selectionMode._elementsBeingManipulated[0] = {
                        element: selectionMode.pdfElements[i],
                        originalPosition: {
                            x: selectionMode.pdfElements[i].x,
                            y: selectionMode.pdfElements[i].y,
                            width: selectionMode.pdfElements[i].width,
                            height: selectionMode.pdfElements[i].height
                        }
                    };
                    i = selectionMode.pdfElements.length;
                }
            }
        }

        selectionMode.cursor = SelectionSubModeResize.cursorForEdge(resizeEdgeAnchor);

        if (resizeEdgeAnchor !== '') {
            return new SelectionSubModeResize(selectionMode, resizeEdgeAnchor);
        } else {
            return null;
        }
    };

    return SelectionSubModeResize;
})();

var SelectionSubModeSelect = (function SelectionSubModeSelectClosure() {
    function SelectionSubModeSelect(selectionMode) {
        SelectionSubModeBase.call(this, selectionMode);
    }

    SelectionSubModeSelect.prototype = Object.create(SelectionSubModeBase.prototype);
    SelectionSubModeSelect.prototype.constructor = SelectionSubModeSelect;

    SelectionSubModeSelect.prototype.onMouseUp = function (mouseEvent, page) {
        var newSelection = this.getElementsWithinSelectionRectangle();
        this._selectionMode.selectedPdfElements.length = 0;

        for (var i = 0; i < newSelection.length; i++) {
            this._selectionMode.selectedPdfElements.push(newSelection[i]);
        }
    };

    SelectionSubModeSelect.prototype.renderToCanvas = function (page) {
        var startPosition = this._selectionMode._mouseStart;
        var endPosition = this._selectionMode._mouseEnd;

        if (this._selectionMode._mouseStartPage !== page) {
            startPosition = coordinates.Position.fromMouseEvent(this._selectionMode._mouseStart, page.pageViewport, page.pdfOverlayCanvasElement);
        }

        if (this._selectionMode._mouseEndPage !== page) {
            endPosition = coordinates.Position.fromMouseEvent(this._selectionMode._mouseEnd, page.pageViewport, page.pdfOverlayCanvasElement);
        }

        page.pdfOverlayCanvasContext.save();
        page.pdfOverlayCanvasContext.lineWidth = 2;
        page.pdfOverlayCanvasContext.setLineDash([5]);
        page.pdfOverlayCanvasContext.strokeStyle = 'white';
        page.pdfOverlayCanvasContext.strokeRect(startPosition.viewportX, startPosition.viewportY, endPosition.viewportX - startPosition.viewportX, endPosition.viewportY - startPosition.viewportY);
        page.pdfOverlayCanvasContext.strokeStyle = 'black';
        page.pdfOverlayCanvasContext.lineDashOffset = 5;
        page.pdfOverlayCanvasContext.strokeRect(startPosition.viewportX, startPosition.viewportY, endPosition.viewportX - startPosition.viewportX, endPosition.viewportY - startPosition.viewportY);
        page.pdfOverlayCanvasContext.restore();
    };

    /**
     * @returns {Array} Instances of PDFedit.elements.PdfElement that are within the selection rectangle drawn by the user.
     */
    SelectionSubModeSelect.prototype.getElementsWithinSelectionRectangle = function () {
        var elementsInRectangle = [];

        var firstPage;
        var lastPage;
        if (this._selectionMode._mouseStartPage.pageNumber < this._selectionMode._mouseEndPage.pageNumber) {
            firstPage = this._selectionMode._mouseStartPage.pageNumber;
            lastPage = this._selectionMode._mouseEndPage.pageNumber;
        } else {
            firstPage = this._selectionMode._mouseEndPage.pageNumber;
            lastPage = this._selectionMode._mouseStartPage.pageNumber;
        }

        var self = this;
        for (var pgNum = firstPage; pgNum <= lastPage; pgNum++) {
            addElementsForPage(this._selectionMode.pages[pgNum - 1]);
        }

        function addElementsForPage(page) {
            var startPosition = self._selectionMode._mouseStart;
            var endPosition = self._selectionMode._mouseEnd;

            if (self._selectionMode._mouseStartPage !== page) {
                startPosition = coordinates.Position.fromMouseEvent(self._selectionMode._mouseStart, page.pageViewport, page.pdfOverlayCanvasElement);
            }

            if (self._selectionMode._mouseEndPage !== page) {
                endPosition = coordinates.Position.fromMouseEvent(self._selectionMode._mouseEnd, page.pageViewport, page.pdfOverlayCanvasElement);
            }

            var selectionRectangle = coordinates.Rectangle.fromPositions(startPosition, endPosition, page.pageViewport);

            for (var i = 0; i < self._selectionMode.pdfElements.length; i++) {
                if (self._selectionMode.pdfElements[i].pageNumber === page.pageNumber &&
                    self._selectionMode.pdfElements[i].x >= selectionRectangle.pdfLeft &&
                    self._selectionMode.pdfElements[i].x + self._selectionMode.pdfElements[i].width <= selectionRectangle.pdfLeft + selectionRectangle.pdfWidth &&
                    self._selectionMode.pdfElements[i].y >= selectionRectangle.pdfBottom &&
                    self._selectionMode.pdfElements[i].y + self._selectionMode.pdfElements[i].height <= selectionRectangle.pdfBottom + selectionRectangle.pdfHeight) {

                    elementsInRectangle.push(self._selectionMode.pdfElements[i]);
                }
            }
        }

        return elementsInRectangle;
    };

    return SelectionSubModeSelect;
})();

var SelectionSubModeTextSpacingEdit = (function SelectionSubModeTextSpacingEditClosure() {

    /**
     * @param {PDFedit.uimodes.SelectionMode} selectionMode
     * @param {PDFedit.elements.PdfTextElement} textElement - The text element that text spacing is being edited in
     * @param {Number} characterIndex - The index of the character being moved on the text element
     */
    function SelectionSubModeTextSpacingEdit(selectionMode, textElement, characterIndex) {
        SelectionSubModeBase.call(this, selectionMode);

        this._textElement = textElement;
        this._characterIndex = characterIndex;
        this._characterOriginalSpacings = textElement.characterSpacings.slice();
    }

    SelectionSubModeTextSpacingEdit.prototype = Object.create(SelectionSubModeBase.prototype);
    SelectionSubModeTextSpacingEdit.prototype.constructor = SelectionSubModeTextSpacingEdit;

    /**
     * @param {MouseEvent} mouseEvent
     * @param {PDFedit.document.Page} page - The page that the mouse event occurred on
     * @param {PDFedit.uimodes.SelectionMode} selectionMode - The SelectionMode object
     *
     * @return {Object} An instance of this sub-mode if this is the sub-mode to be used, otherwise null
     */
    SelectionSubModeTextSpacingEdit.checkForSubMode = function (mouseEvent, page, selectionMode) {
        for (var i = 0; i < selectionMode.pdfElements.length; i++) {
            if (selectionMode.pdfElements[i].pageNumber === selectionMode._mouseStartPage.pageNumber &&
                selectionMode.pdfElements[i] instanceof PdfTextElement &&
                selectionMode.pdfElements[i].characterCount > 0 &&
                selectionMode.pdfElements[i].hitTest(selectionMode._mouseStartPage.pageViewport, selectionMode._mouseStartPage.pdfOverlayCanvasElement, selectionMode._mouseStart)) {

                var characterIndex = selectionMode.pdfElements[i].mousePositionCharacterHit(page, mouseEvent);
                if (characterIndex !== -1) {

                    // If there are no explicit character spacings, set up defaults
                    if (selectionMode.pdfElements[i].characterSpacings.length === 0) {
                        selectionMode.pdfElements[i].setDefaultCharacterSpacings();
                    }

                    return new SelectionSubModeTextSpacingEdit(selectionMode, selectionMode.pdfElements[i], characterIndex);
                }
            }
        }

        return null;
    };

    /**
     * @param {MouseEvent} mouseEvent
     * @param {PDFedit.document.Page} page - The page that the mouse event occurred on
     */
    SelectionSubModeTextSpacingEdit.prototype.onMouseMove = function (mouseEvent, page) {
        var minimumSpacing = this._textElement.fontSize;
        var minimumEndSpacing = this._textElement.fontSize / 2;

        var movementX = this._selectionMode._mouseEnd.pdfX - this._selectionMode._mouseStart.pdfX;

        var index;

        // Reset all characters to original spacing, this helps prevent *both* sides getting
        // bunched up due to rapid left-right mouse movement.
        index = 0;
        while (index < this._textElement.characterSpacings.length) {
            this._textElement.characterSpacings[index] = this._characterOriginalSpacings[index];
            index++;
        }

        if (movementX < 0) {
            // Moving left

            // Iterate through characters from right-to-left, starting with the one being moved.
            // Subtract the movement distance from the character spacing, but if that would result
            // in a spacing less than the minimum allowed (or a negative), set the spacing to minimum
            // and subtract remaining movement distance from characters to the left.

            index = this._characterIndex;
            while (movementX < 0 && index >= 0) {
                if (index === 0) {
                    if (this._characterOriginalSpacings[index] + movementX < minimumEndSpacing) {
                        this._textElement.characterSpacings[index] = minimumEndSpacing;
                    } else {
                        this._textElement.characterSpacings[index] = this._characterOriginalSpacings[index] + movementX;
                    }
                } else {
                    if (this._characterOriginalSpacings[index] + movementX < minimumSpacing) {
                        this._textElement.characterSpacings[index] = minimumSpacing;
                        movementX += this._characterOriginalSpacings[index] - minimumSpacing;
                    } else {
                        this._textElement.characterSpacings[index] = this._characterOriginalSpacings[index] + movementX;
                        movementX = 0;
                    }
                }

                index--;
            }
        }

        if (movementX > 0) {
            // Moving right

            this._textElement.characterSpacings[this._characterIndex] = this._characterOriginalSpacings[this._characterIndex] + movementX;

            // If this movement would result in characters extending beyond the width of the box,
            // characters to the right of the moving character will need to be bunched up.
            // Bunching-up starts from the right most character.

            var proposedTotalWidth = 0;
            for (index = 0; index < this._characterIndex; index++) {
                proposedTotalWidth += this._characterOriginalSpacings[index];
            }
            proposedTotalWidth += this._characterOriginalSpacings[this._characterIndex] + movementX;
            for (index = this._characterIndex + 1; index < this._characterOriginalSpacings.length; index++) {
                proposedTotalWidth += this._characterOriginalSpacings[index];
            }
            proposedTotalWidth += minimumEndSpacing;

            if (proposedTotalWidth > this._textElement.width) {

                // Squash factor is how much beyond the right-most edge of the box this movement has gone.
                // The squash needs to be applied to other characters until everything fits within the box.
                // If there is left-over squash factor, movement limit is applied by subtracting the remaining
                // squash factor from the character being moved.

                var squashX = proposedTotalWidth - this._textElement.width;

                index = this._characterOriginalSpacings.length - 1;
                while (squashX > 0 && index > this._characterIndex) {

                    if (this._characterOriginalSpacings[index] - squashX < minimumSpacing) {
                        this._textElement.characterSpacings[index] = minimumSpacing;
                        squashX -= this._characterOriginalSpacings[index] - minimumSpacing;
                    } else {
                        this._textElement.characterSpacings[index] = this._characterOriginalSpacings[index] - squashX;
                        squashX = 0;
                    }

                    index--;
                }

                if (squashX > 0) {
                    this._textElement.characterSpacings[this._characterIndex] -= squashX;
                }
            }
        }
    };

    return SelectionSubModeTextSpacingEdit;
})();

module.exports = SelectionMode;

var coordinates = require('../Coordinates');
var PdfTextElement = require('../Elements/pdf-text-element.js');